import { cn } from 'utils/cn';
import './SpinnerDots.less';

export function SpinnerDots({ className }: { className?: string }) {
	return (
		<span data-test="spinner-dots" class={cn('spinner-dots', className)}>
			<span>.</span>
			<span>.</span>
			<span>.</span>
		</span>
	);
}
